<script lang="ts" setup>
import type { ToMetaTagsType } from "vue-datocms";
import type { HeaderSectionRecord, NewsRecord } from "~~/server/graphql/datocms/generated";
import { toHead } from "vue-datocms";

const { locale } = useI18n();
const { params } = useRoute();
const slug = params.slug || "home";

const { data } = await useFetch<NewsRecord>("/api/cms/news/detail", {
  query: { slug: slug, locale: locale },
});

if (!data.value) {
  throw create404Error();
}

useDatoSlugsToI18n(data.value._allSlugLocales!);

useHead(() => {
  if (!data.value) {
    return {};
  }

  return toHead(data.value._seoMetaTags as ToMetaTagsType);
});

const headerSection = computed(() => {
  return data.value?.sections.find(s => s.__typename === "HeaderSectionRecord") as HeaderSectionRecord;
});

const bodySections = computed(() => {
  return data.value?.sections.filter(s => s.__typename !== "HeaderSectionRecord");
});
</script>

<template>
  <div class="mt-3xl">
    <Breadcrumbs class="mb-sm" :page="data" page-type="news" />

    <article v-if="data">
      <div v-if="headerSection" class="header-section">
        <SectionsHeader :data="headerSection" :page-title="data.title" :current-page-id="data.id" />
      </div>

      <div class="mb-xl flex justify-center">
        <div class="w-full lg:w-3/5">
          <h1 class="header-section__title mb-lg mt-3xl md:mb-xl text-left md:text-center">
            {{ data.title }}
          </h1>

          <div class="mb-lg flex justify-end">
            <div>{{ new Date(data._publishedAt!).toLocaleDateString(locale, { year: "numeric", month: "long", day: "numeric" }) }}</div>
          </div>

          <hr class="border-neutral-100">
        </div>
      </div>

      <SectionsRenderer :sections="bodySections" :page-title="data.title" :current-page-id="data.id" />
    </article>
  </div>
</template>

<style>
article:has(.header-section img) {
  .header-section__title {
    display: none;
  }
}
</style>
